function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10.2891C12 11.1094 11.3438 11.7891 10.5 11.7891H1.5C0.679688 11.7891 0 11.1094 0 10.2891V4.38281C0 4.03125 0.1875 3.67969 0.492188 3.46875L4.82812 0.46875C5.53125 0 6.46875 0 7.17188 0.46875L11.5312 3.46875C11.8125 3.67969 12 4.03125 12 4.38281V10.2891ZM1.5 10.6641H10.5C10.7109 10.6641 10.875 10.5 10.875 10.2891V5.78906L7.24219 8.55469C6.51562 9.11719 5.48438 9.11719 4.75781 8.55469L1.125 5.78906V10.2891C1.125 10.5 1.28906 10.6641 1.5 10.6641ZM10.875 4.38281L6.53906 1.40625C6.21094 1.17188 5.78906 1.17188 5.46094 1.40625L1.125 4.38281L5.4375 7.66406C5.76562 7.89844 6.23438 7.89844 6.5625 7.66406L10.875 4.38281Z",
  fill: "#636766"
});

function SvgEnvelopeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.23d3d5cc.svg";
export { ForwardRef as ReactComponent };